<template>
<div class="chartbar2">
  <div :id="'bar2Serise'+idhash" style="width:100%;height:100%;"></div>
  <div class="nodata" v-if="data.length==0">
    暂无数据
  </div>
</div>
</template>
 
 


<script>
import chart from "../../utils/chartDark";
import {secondToHM} from "../../utils/commons"
import echarts from 'echarts'
export default {
  mixins: [chart],
  data: function() {
    return {
      idhash: null,
      isInit: false,
      chart: null,
      clickDoTime: null, //单双击
      data:[1]
    };
  },
  props: ['dataBar','colorSet','legendGrid','grid'],
  created() {
    this.idhash = this.uuid();
  },
  mounted(){
  },
  methods: {
    getOptAndDraw: function() {
      console.log('aaa')
    var title = this.dataBar.title;//两种状态
    // echart配置
    var option = {
        color: this.colorSet,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          },
          textStyle:{
            align:'left'
          },
          formatter:(params)=>{
            let runTime=0
            let workTime=0
            let stateTime=0
            // console.log(params,'params')
            params.map(item=>{
              if(item.name=='作业时长'){
                workTime+=item.value[2]-item.value[1]
              }else if(item.name=='怠速时长'){
                stateTime+=item.value[2]-item.value[1]
              }
            })
            runTime=workTime+stateTime
            // console.log(runTime,workTime,stateTime,'time')
            let str=''
            if(this.dataBar.period==0){
              str+=params[0].name+'</br>'
              str+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:transparent;"></span>'+'开机时长:'+ secondToHM(runTime)+'</br>'
              str+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+this.colorSet[0]+';"></span>'+title[0]+":"+ secondToHM(workTime)+'</br>'
              str+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+this.colorSet[1]+';"></span>'+title[1]+":"+ secondToHM(stateTime)+'</br>'
              str+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+this.colorSet[2]+';"></span>'+title[2]+":"+ params[0].value+'%</br>'
              return str
            }else{
              str+=params[0].name+'</br>'
              str+=params[0].name+'-01~'
              str+=params[0].name+'-'+new Date(params[0].name.slice(0,4),params[0].name.slice(5,7),0).getDate()+'</br>'
              str+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:transparent;"></span>'+'累计开机时长:'+ secondToHM(runTime)+'</br>'
              str+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+this.colorSet[0]+';"></span>'+"累计作业时长:"+ secondToHM(workTime)+'</br>'
              str+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+this.colorSet[1]+';"></span>'+"累计怠速时长:"+ secondToHM(stateTime)+'</br>'
              str+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+this.colorSet[2]+';"></span>'+"平均利用率:"+ params[0].value+'%</br>'
              return str
            }
          }
        },
        legend: {
          icon: 'rect',
          itemHeight: 10,
          itemWidth: 10,
          data: title,
          textStyle: {
            fontSize:12,
            color: "#8C8C8C",
            padding: [0,0,0,0],
          },
          // left: 24,
          itemGap:16,
          right: this.legendGrid[1],
          top: this.legendGrid[0],
        },
        grid: {
          top: this.grid[0],
          right: this.grid[1],
          bottom: this.grid[2],
          left: this.grid[3]?this.grid[3]:null,
          containLabel: false
        },
        xAxis:[ {                   
                type: 'value',
                splitNumber:this.dataBar.period==0?12:5,
                max:this.dataBar.period==0?24:this.dataBar.max,
                position:'top',
                name: '时长：H',
                nameTextStyle:{
                  color: '#8C8C8C',
                  padding:[0,15,0,0]
                },
                axisLabel: {
                  fontSize: 12,
                  textStyle:{
                    fontSize: 12,
                    color: '#8C8C8C'
                  }
                },
                splitLine:{
                  show:true,
                  lineStyle:{
                    color:'#F0F0F0',
                    type:'solid'
                  }
                },
                axisLine:{
                  show:false
                },
                axisTick:{
                  lineStyle:{
                    width:0,
                  }, 
                },
            },{
                type:'value',
                name:'设备利用率',
                nameTextStyle:{
                    color: '#8C8C8C',
                    padding:[0,0,0,15]
                },
                axisLabel: {
                  fontSize: 12,
                  textStyle:{
                    fontSize: 12,
                    color: '#8C8C8C'
                  },
                  formatter:'{value} %'
                },
                axisLine:{
                  show:false
                },
                axisTick:{
                  lineStyle:{
                    width:0,
                  }, 
                },
                splitLine:{
                    show:false,
                },
                position:'bottom',
            }
        ],
        yAxis: {
          type:'category',
          data: this.dataBar.yAxis,
          axisLabel: {
            fontSize: 12,
            padding:[0,0,0,0],
            textStyle:{
              fontSize: 12,
              color: '#8C8C8C'
            }
          },
          axisLine:{
            show:false,
            lineStyle:{
              color:'#8C8C8C'
            }
          },
          axisTick:{
            show:false
          }
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: 100,
            end: 100-((this.dataBar.dataZoomEnd) || 30),
            handleSize: "10%",
            width: 8,
            handleStyle: {
              borderWidth: 0,
            },
            fillerColor: "#e4e3e8",
            yAxisIndex: [0],
            top:'15%',
            left:'0%'
          },
          {
            type: "inside",
            yAxisIndex: [0], 
            show: false,
          },
        ],
        series: [
            
            // 用空bar来显示四个图例
            { name: this.dataBar.title[0], type: 'bar',xAxisIndex:0, data: [] },
            { name: this.dataBar.title[1], type: 'bar',xAxisIndex:0, data: [] },
            { name: this.dataBar.title[2],type:'line',xAxisIndex:1,data:this.dataBar.lineData},
            {
                type: 'custom',                
                renderItem: function (params, api) {//开发者自定义的图形元素渲染逻辑，是通过书写 renderItem 函数实现的
                    var categoryIndex = api.value(0);//这里使用 api.value(0) 取出当前 dataItem 中第一个维度的数值。
                    var start = api.coord([api.value(1), categoryIndex]); // 这里使用 api.coord(...) 将数值在当前坐标系中转换成为屏幕上的点的像素值。
                    var end = api.coord([api.value(2), categoryIndex]);
                    var height = 12;//柱体宽度
 
                    return {
                        type: 'rect',// 表示这个图形元素是矩形。还可以是 'circle', 'sector', 'polygon' 等等。
                        shape: echarts.graphic.clipRectByRect({ // 矩形的位置和大小。
                            x: start[0],
                            y: start[1] - height / 2,
                            width: end[0] - start[0],
                            height: height
                        }, { // 当前坐标系的包围盒。
                            x: params.coordSys.x,
                            y: params.coordSys.y,
                            width: params.coordSys.width,
                            height: params.coordSys.height
                        }),
                        style: api.style()
                    };
                },
                encode: {
                    x: [1, 2], // data 中『维度1』和『维度2』对应到 X 轴
                    y: 0// data 中『维度0』对应到 Y 轴
                },
                data: this.dataBar.barData // 维度0 维度1 维度2
            }
        ]
    };
      // this.chart.clear();
      // console.log(option,'option');
      if (option && typeof option === "object") {
        this.chart.setOption(option)
      }
    },
    initChart: function() {
      if (this.isInit == false) {
          // console.log('canvas')
        var dom = document.getElementById("bar2Serise" + this.idhash);
        this.chart = echarts.init(dom);
        // this.chart.on("dataZoom", function(params) {
        //   console.log(params,'params')
        // });
        this.isInit = true;
      }
    },
  },
  watch: {
    dataBar: {
       handler(){
          if (this.isInit == false) {
              this.initChart();
          }
          this.chart.clear();
          console.log(this.chart)
          console.log('initaa')
          this.getOptAndDraw();
          this.chart.resize();
          console.log(this.data,'data')
          if(this.dataBar.lineData.length==0){
            this.data=this.dataBar.lineData
            this.chart.clear();
          }
        },
        deep: true,
        immediate: true
    }
  },
  components: {}
};
</script>   
 <style lang="scss" scoped>
.chartbar2 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .nodata{
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba($color: #ffffff, $alpha: 0.7);
      z-index: 100;
      text-align: center;
      line-height: 300px;
    }
}
</style>
 
   